import { FEATURE_CODES, FeatureCode } from "../../constants/constants";

export type ReportCategory =
  | "Services & attendance"
  | "Contacts & data quality"
  | "Communications";

export type ReportIcon = "session-summary" | "contact-issues" | "archived-parties";

export interface ReportDefinition {
  id: string;
  title: string;
  description: string;
  category: ReportCategory;
  path: string;
  icon: ReportIcon;
  feature?: FeatureCode;
}

export const REPORT_CATEGORIES: readonly ReportCategory[] = [
  "Services & attendance",
  "Contacts & data quality",
  "Communications",
];

export const REPORTS: readonly ReportDefinition[] = [
  {
    id: "archived-parties",
    title: "Archived Parties",
    description: "View archived people, families and organisations linked to your organisation.",
    category: "Contacts & data quality",
    path: "/reports/archived-parties",
    icon: "archived-parties",
  },
  {
    id: "session-summary",
    title: "Session Summary",
    description:
      "Combine completed session retrospectives into an editable summary.",
    category: "Services & attendance",
    path: "/reports/session-summary",
    icon: "session-summary",
    feature: FEATURE_CODES.SERVICE_SESSION_REPORTS,
  },
  {
    id: "contact-issues",
    title: "Contact Issues",
    description:
      "Find missing or unverified contact information that needs attention.",
    category: "Contacts & data quality",
    path: "/reports/contacts",
    icon: "contact-issues",
  },
];
